export default __webpack_public_path__ + "static/media/banner-1.18bb5f93.svg";